export default __webpack_public_path__ + "static/media/RW.e62c1c4e.svg";